import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "@/services/axiosAuth";

interface getProps {
  communityId: string;
  id: string;
  module: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getPropertyCategoryById = async (communityId: string, id: string, module: string) =>
  await axiosAuth.get(`v1/${module}/community/${communityId}/${id}`);

const useGetPropertyCategoryById = ({
  communityId,
  id,
  module,
  queryParams
}: getProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: [module, id],
    queryFn: () => getPropertyCategoryById(communityId, id, module),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetPropertyCategoryById;
